import React, { useEffect, useState } from "react";
import { Center, Text, Spinner } from "native-base";
import { getAuth, signInWithCustomToken, setPersistence, browserLocalPersistence } from "firebase/auth";
import { Platform } from "react-native";

// Se você está usando react-router-dom para web:
import { useNavigate } from "react-router-dom";

// Para mobile, receber via props
// import { StackScreenProps } from '@react-navigation/stack';
// import { RootStackParamList } from "../types";

const AutoLoginScreen: React.FC<any> = (props) => {
  const [error, setError] = useState<string | null>(null);
  // Para web, use useNavigate do react-router-dom:
  const navigate = useNavigate();

useEffect(() => {
  const auth = getAuth();

  // Verifica se o usuário já está autenticado
  const unsubscribe = onAuthStateChanged(auth, (user) => {
    if (user) {
      // Já está logado → redireciona para Home
      if (typeof navigate === "function") {
        navigate("/home", { replace: true });
      } else if (props.navigation?.reset) {
        props.navigation.reset({
          index: 0,
          routes: [{ name: "Home" }],
        });
      }
    } else {
      // Continua com o login via token
      let token: string | null = null;

      if (typeof window !== "undefined" && window.location?.search) {
        const params = new URLSearchParams(window.location.search);
        token = params.get("token");
      }

      if (!token && props.route?.params?.token) {
        token = props.route.params.token;
      }

      if (token) {
        setPersistence(auth, browserLocalPersistence)
          .then(() => signInWithCustomToken(auth, token))
          .then(() => {
            if (typeof navigate === "function") {
              navigate("/home", { replace: true });
            } else if (props.navigation?.reset) {
              props.navigation.reset({
                index: 0,
                routes: [{ name: "Home" }],
              });
            }
          })
          .catch((err) => {
            setError("Não foi possível fazer login automático.");
            setTimeout(() => {
              if (typeof navigate === "function") {
                navigate("/auth");
              } else if (props.navigation?.navigate) {
                props.navigation.navigate("Auth");
              }
            }, 3000);
          });
      } else {
        setError("Token não informado.");
        setTimeout(() => {
          if (typeof navigate === "function") {
            navigate("/auth");
          } else if (props.navigation?.navigate) {
            props.navigation.navigate("Auth");
          }
        }, 3000);
      }
    }
  });

  return () => unsubscribe();
}, []);



  return (
    <Center flex={1}>
      <Text mb={4}>Fazendo login automático...</Text>
      <Spinner />
      {error && <Text color="red.500" mt={2}>{error}</Text>}
    </Center>
  );
};

export default AutoLoginScreen;
